// GWV theme global script.
// Add interactive behaviors here. Most of the storefront is server-rendered Liquid.

document.addEventListener('DOMContentLoaded', () => {
  // Reveal-on-scroll for editorial sections.
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.gwv-editorial, .gwv-strip, .gwv-quote').forEach(el => io.observe(el));
});
// Reset product image swap on touch devices
document.addEventListener('touchstart', function(e) {
  var cards = document.querySelectorAll('#product-grid .card-wrapper, .gwv-sig-card');
  cards.forEach(function(card) {
    if (!card.contains(e.target)) {
      card.classList.add('touch-reset');
      setTimeout(function() { card.classList.remove('touch-reset'); }, 50);
    }
  });
}, { passive: true });
// Force mobile header logo visible
function gwvFixMobileHeader() {
  if (window.innerWidth > 989) return;
  var heading = document.querySelector('.header__heading');
  var logo = document.querySelector('.header__heading-logo');
  var logoWrapper = document.querySelector('.header__heading-logo-wrapper');
  var link = document.querySelector('.header__heading-link');
  if (heading) {
    heading.style.cssText = 'position:absolute!important;left:50%!important;top:50%!important;transform:translate(-50%,-50%)!important;display:block!important;visibility:visible!important;opacity:1!important;z-index:2!important;margin:0!important;';
  }
  if (link) {
    link.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;padding:0!important;';
  }
  if (logoWrapper) {
    logoWrapper.style.cssText = 'display:block!important;visibility:visible!important;width:auto!important;';
  }
  if (logo) {
    logo.style.cssText = 'display:block!important;max-height:28px!important;width:auto!important;visibility:visible!important;opacity:1!important;';
  }
}

document.addEventListener('DOMContentLoaded', gwvFixMobileHeader);
window.addEventListener('resize', gwvFixMobileHeader);